import {useSourcingGetTopSellingQuery} from '@dms/api/core';

import {DEFAULT_SOURCING_TARGET_COUNTRY} from '../constants/DEFAULT_SOURCING_TARGET_COUNTRY';
import {useSourcingTargetCountry} from './useSourcingTargetCountry';

/** Shared query for the model list and make shortcuts; never reuse another market's data. */
export function useSourcingTopSelling() {
  const targetCountry = useSourcingTargetCountry();

  return useSourcingGetTopSellingQuery({
    size: 20,
    body: {seller: {country: [targetCountry?.code ?? DEFAULT_SOURCING_TARGET_COUNTRY]}},
  });
}
